// Minimal, non-invasive attribution. No fingerprinting — random ids + page/referrer/UTM only.
const FIRST_KEY = "ozy_attr_first";
const ANON_KEY = "ozy_anon_id";
const SESSION_KEY = "ozy_session_id";
const SEARCH_KEY = "ozy_last_search";

const safeGet = (store, k) => { try { return store.getItem(k); } catch (_e) { return null; } };
const safeSet = (store, k, v) => { try { store.setItem(k, v); } catch (_e) { /* noop */ } };
const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export function getAnonId() {
  let id = safeGet(localStorage, ANON_KEY);
  if (!id) { id = uuid(); safeSet(localStorage, ANON_KEY, id); }
  return id;
}

export function getSessionId() {
  let id = safeGet(sessionStorage, SESSION_KEY);
  if (!id) { id = uuid(); safeSet(sessionStorage, SESSION_KEY, id); }
  return id;
}

export function captureFirstTouch() {
  if (typeof window === "undefined" || safeGet(localStorage, FIRST_KEY)) return;
  const p = new URLSearchParams(window.location.search);
  const first = {
    landing_page: window.location.pathname + window.location.search,
    referrer: document.referrer || "",
    utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "", utm_term: p.get("utm_term") || "", utm_content: p.get("utm_content") || "",
    at: new Date().toISOString(),
  };
  safeSet(localStorage, FIRST_KEY, JSON.stringify(first));
}

export function rememberSearch({ search_id, phrase, category, universe }) {
  const prev = getLastSearch() || {};
  safeSet(sessionStorage, SEARCH_KEY, JSON.stringify({ search_id, phrase, category, universe: universe || prev.universe || "" }));
}

// Funding-universe click (BANKS. / NON-BANKS. / …) — non-PII discovery context carried into search + lead attribution
export function rememberUniverse(universe) {
  const prev = getLastSearch() || {};
  safeSet(sessionStorage, SEARCH_KEY, JSON.stringify({ ...prev, universe }));
}

export function getLastSearch() {
  try { return JSON.parse(safeGet(sessionStorage, SEARCH_KEY) || "null"); } catch (_e) { return null; }
}

export function buildAttribution(extra = {}) {
  let first = {};
  try { first = JSON.parse(safeGet(localStorage, FIRST_KEY) || "{}"); } catch (_e) { first = {}; }
  const last = getLastSearch() || {};
  return {
    landing_page: first.landing_page || "", referrer: first.referrer || "",
    utm_source: first.utm_source || "", utm_medium: first.utm_medium || "", utm_campaign: first.utm_campaign || "",
    utm_term: first.utm_term || "", utm_content: first.utm_content || "",
    anonymous_visitor_id: getAnonId(), session_id: getSessionId(),
    search_id: last.search_id || "", ozy_search_phrase: last.phrase || "", finance_category: last.category || "",
    funding_universe_category: last.universe || "",
    conversion_page: typeof window !== "undefined" ? window.location.pathname : "",
    device_type: typeof window !== "undefined" && window.innerWidth < 768 ? "mobile" : "desktop",
    ...extra,
  };
}
